import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { AppLogo } from 'src/components/icon/AppLogo';
import { AccountIcon } from 'src/components/icon/Common';
import getConfig, { FEATURES } from 'src/services/config';
import { menuItemType, useMenusMobile } from 'src/utils/menu';

import {
  WalletContext,
  getAccountName,
  getCurrentWallet,
  getSelectedWallet,
} from '../../utils/wallets-integration';
import { HiOutlineExternalLink } from '../reactIcons';
import CopyToClipboard from 'react-copy-to-clipboard';
import {
  ArrowDownIcon,
  ArrowDownLargeIcon,
  HiMenuIcon,
  OutLinkIcon,
} from 'src/components/icon/Nav';

import {
  ACCOUNT_ID_KEY,
  useWalletSelector,
} from '../../context/WalletSelectorContext';
import { isNewHostName } from '../../services/config';
import { BuyNearButton } from '../button/Button';
import { CopyIcon } from '../icon/CrossSwapIcons';
import { AccountTipDownByAccountID } from './NavigationBar';
import { CONST_ACKNOWLEDGE_WALLET_RISK } from 'src/constants/constLocalStorage';
import { WalletRiskCheckBoxModal } from 'src/context/modal-ui/components/WalletOptions/WalletRiskCheckBox';
import { KeyIcon } from '../../components/portfolio/icons';
import AccessKeyModal from '../../components/portfolio/AccessKeyModal';

import { wrapHistoryMethodWithEvent } from '../../utils/historyEvents';
import { openUrl } from '../../utils/navigation';

function AccountModel(props: any) {
  const history = useHistory();
  const accountWrapRef = useRef(null);
  const [showTip, setShowTip] = useState<boolean>(false);
  const [copyButtonDisabled, setCopyButtonDisabled] = useState<boolean>(false);

  const { wallet } = getCurrentWallet();

  const { hasBalanceOnRefAccount, setAccountVisible, setKeyModalShow } = props;
  const { modal, accountId } = useWalletSelector();
  const accountList = [
    {
      icon: <AccountIcon />,
      textId: 'your_assets',
      selected: location.pathname == '/overview',
      click: () => {
        history.push('/overview');
      },
    },
  ];

  const [currentWalletName, setCurrentWalletName] = useState<string>();

  const [currentWalletIcon, setCurrentWalletIcon] = useState<string>();
  const signOut = async () => {
    const curWallet = await getSelectedWallet(wallet);
    if (!curWallet) {
      localStorage.removeItem(ACCOUNT_ID_KEY);
      window.location.assign('/');
      return;
    }

    await curWallet.signOut();

    localStorage.removeItem(ACCOUNT_ID_KEY);
    window.location.assign('/');
  };

  useEffect(() => {
    // Same as the desktop account menu: no wallet selected is a signed-out page, not a failure.
    if (!accountId) {
      setCurrentWalletName(undefined);
      setCurrentWalletIcon(undefined);
      return;
    }
    let cancelled = false;
    getSelectedWallet(wallet)
      .then((selectedWallet) => {
        if (cancelled || !selectedWallet) return;
        setCurrentWalletName(selectedWallet.metadata.name);
        setCurrentWalletIcon(selectedWallet.metadata.iconUrl);
      })
      .catch((err) => {
        console.error(err);
      });
    return () => {
      cancelled = true;
    };
  }, [accountId]);

  const [copyIconHover, setCopyIconHover] = useState<boolean>(false);

  const handleClick = (event: any) => {
    // this not working anymore
    // if (!accountWrapRef.current.contains(e.target)) {
    //   props.closeAccount();
    // }
  };
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.addEventListener('click', handleClick, false);
    return () => {
      document.body.style.overflow = 'auto';
      document.removeEventListener('click', handleClick, false);
    };
  }, []);
  function showToast() {
    if (copyButtonDisabled) return;
    setCopyButtonDisabled(true);
    setShowTip(true);
    setTimeout(() => {
      setShowTip(false);
      setCopyButtonDisabled(false);
    }, 1000);
  }
  const isDisableChangeWallet = ['keypom', 'Keypom Account'].includes(
    currentWalletName
  );
  return (
    <div
      className="fixed left-0 bottom-0 w-screen bg-black bg-opacity-70"
      style={{
        backdropFilter: 'blur(15px)',
        WebkitBackdropFilter: 'blur(15px)',
        top:
          hasBalanceOnRefAccount && window.location.pathname !== '/account'
            ? '6.3rem'
            : '4.2rem',
      }}
    >
      <div className="w-full bg-cardBg" ref={accountWrapRef}>
        <div className="mx-7 pt-4 flex justify-between items-start">
          <div className="mb-accountId text-white text-lg text-left flex-col flex">
            <span>{getAccountName(wallet.getAccountId())}</span>

            <span className="flex items-center ">
              {currentWalletIcon && (
                <span className="mr-1">
                  <img src={currentWalletIcon} className="w-3 h-3" alt="" />
                </span>
              )}
              <span className="text-xs text-primaryText">
                {currentWalletName || '-'}
              </span>
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex items-center justify-center relative">
              <CopyToClipboard text={wallet.getAccountId()} onCopy={showToast}>
                <div
                  className={`bg-black bg-opacity-30  rounded-xl flex items-center justify-center p-1 cursor-pointer`}
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                  onTouchStart={() => {
                    setCopyIconHover(true);
                  }}
                  onTouchEnd={() => {
                    setCopyIconHover(false);
                  }}
                >
                  <CopyIcon fillColor={copyIconHover ? '#4075FF' : '#7E8A93'} />
                </div>
              </CopyToClipboard>
              {showTip ? (
                <span className="text-xs text-white rounded-lg px-2.5 py-1.5 absolute bottom-8 bg-mobileOrderBg z-50">
                  Copied!
                </span>
              ) : null}
            </div>
            <button
              className="hover:text-gradientFrom text-primaryText w-6 h-6 flex items-center justify-center ml-2 p-0.5 rounded-xl bg-black bg-opacity-30"
              onClick={() => {
                openUrl(
                  `https://${
                    getConfig().networkId === 'testnet' ? 'testnet.' : ''
                  }nearblocks.io/address/${wallet.getAccountId()}#transaction`
                );
              }}
            >
              <HiOutlineExternalLink size={18} />
            </button>
          </div>
        </div>

        <div className="flex mx-7 my-3 items-center text-xs justify-center">
          <button
            className={`mr-2 w-1/2 py-2.5 border rounded-lg border-opacity-30 ${
              isDisableChangeWallet
                ? 'border-gray-500 text-gray-500 cursor-default'
                : 'text-BTCColor hover:border-transparent hover:bg-opacity-20 hover:bg-BTCColor border-BTCColor'
            }`}
            disabled={isDisableChangeWallet}
            onClick={() => {
              signOut();
            }}
          >
            <FormattedMessage id="disconnect" defaultMessage={'Disconnect'} />
          </button>

          <button
            className={`ml-2 w-1/2 py-2.5 border rounded-lg border-opacity-30 ${
              isDisableChangeWallet
                ? 'border-gray-500 text-gray-500 cursor-default'
                : 'text-gradientFrom border-gradientFrom hover:border-transparent hover:bg-gradientFrom hover:bg-opacity-20'
            }`}
            onClick={async () => {
              modal.show();
            }}
            disabled={isDisableChangeWallet}
          >
            <FormattedMessage id="change" defaultMessage={'Change'} />
          </button>
        </div>

        {accountList.map((account, index) => {
          return (
            <>
              <div
                onClick={() => {
                  account.click();
                  props.closeAccount();
                }}
                key={account.textId + index}
                className={`flex items-center text-base cursor-pointer font-semibold py-4 pl-20 hover:text-white hover:bg-navHighLightBg ${
                  account.selected
                    ? 'text-white bg-navHighLightBg'
                    : 'text-primaryText'
                }`}
              >
                <label className="w-9 text-left cursor-pointer">
                  {account.icon}
                </label>
                <label className="cursor-pointer">
                  <FormattedMessage id={account.textId}></FormattedMessage>
                </label>

                {/* {item.subIcon ? (
                  <label className="text-lg ml-2">{item.subIcon}</label>
                ) : null} */}
              </div>
              <div
                onClick={() => {
                  setKeyModalShow(true);
                  setAccountVisible(false);
                }}
                className={`flex items-center text-base cursor-pointer font-semibold py-4 pl-20 hover:text-white hover:bg-navHighLightBg text-primaryText`}
              >
                <label className="w-9">
                  <KeyIcon />
                </label>
                <label className="cursor-pointer text-base">Approved Key</label>
              </div>
              {hasBalanceOnRefAccount && account.textId === 'your_assets' ? (
                <div
                  className="text-center py-0.5 font-normal bg-gradientFrom w-full cursor-pointer text-xs"
                  onClick={account.click}
                  style={{
                    color: '#001320',
                  }}
                >
                  <FormattedMessage
                    id="ref_account_tip_2"
                    defaultMessage="You have token(s) in your REF Account"
                  />
                </div>
              ) : null}
            </>
          );
        })}
      </div>
    </div>
  );
}
export function MobileNavBar(props: any) {
  const [show, setShow] = useState(false);
  const iconRef = useRef<HTMLSpanElement | null>(null);
  const popupRef = useRef<HTMLDivElement | null>(null);
  const [openMenu, setOpenMenu] = useState('');
  const [openChildMenu, setOpenChildMenu] = useState('');
  const [pathnameState, setPathnameState] = useState<boolean>(
    window.location.pathname !== '/account'
  );
  const { modal, accountId } = useWalletSelector();
  const { hasBalanceOnRefAccount } = props;
  const { globalState } = useContext(WalletContext);
  const isSignedIn = globalState.isSignedIn;
  const menusMobile_temp = useMenusMobile(setShow);
  const [showTip, setShowTip] = useState<boolean>(false);
  const [one_level_selected, set_one_level_selected] = useState<string>('');
  const [two_level_selected, set_two_level_selected] = useState<string>('');
  const [showWalletRisk, setShowWalletRisk] = useState<boolean>(false);
  const [keyModalShow, setKeyModalShow] = useState<boolean>(false);
  const handleWalletModalOpen = () => {
    const isAcknowledgeWalletRisk = localStorage.getItem(
      CONST_ACKNOWLEDGE_WALLET_RISK
    );
    if (!isAcknowledgeWalletRisk) {
      setShowWalletRisk(true);
    } else {
      modal.show();
    }
  };
  const handleAcknowledgeClick = (status) => {
    if (status === true) {
      setShowWalletRisk(false);
      localStorage.setItem(CONST_ACKNOWLEDGE_WALLET_RISK, '1');
      modal.show();
    }
  };

  const menusMobile = useMemo(() => {
    if (menusMobile_temp) {
      const menus_final = menusMobile_temp.filter((menuItem: menuItemType) => {
        return !menuItem.hidden;
      });
      return menus_final;
    }
  }, [menusMobile_temp]);
  useEffect(() => {
    const pathname = '/' + location.pathname.split('/')[1];
    let one_level_selected_id = '';
    let two_level_selected_id = '';
    const swap_mode_in_localstorage =
      localStorage.getItem('SWAP_MODE_VALUE') || 'normal';
    if (menusMobile) {
      const one_level_menu = menusMobile.find((menuItem: menuItemType) => {
        const { links } = menuItem;
        return links?.indexOf(pathname) > -1;
      });
      if (one_level_menu) {
        const { id, children } = one_level_menu;
        one_level_selected_id = id;
        const second_children: any = children;
        if (second_children) {
          const two_level_menu = second_children.find(
            (childMenuItem: menuItemType) => {
              const { links, swap_mode } = childMenuItem;
              const condition = isNewHostName
                ? pathname == '/swap'
                : pathname == '/' || pathname == '/swap';
              if (condition) {
                return swap_mode_in_localstorage == swap_mode;
              } else {
                return links?.indexOf(pathname) > -1;
              }
            }
          );
          setOpenMenu(id);
          if (two_level_menu) {
            two_level_selected_id = two_level_menu.id;
          }
        }
      } else {
        menusMobile.find((menuItem) => {
          const match = menuItem.links.includes(pathname);
          if (!match && Array.isArray(menuItem.children)) {
            const level2Match = menuItem.children.find((childMenuItem) =>
              childMenuItem.links?.includes(pathname)
            );
            if (level2Match) {
              two_level_selected_id = level2Match.id;
              one_level_selected_id = menuItem.id;
              setOpenMenu(menuItem.id);
            }
          }
          return match;
        });
      }
      set_one_level_selected(one_level_selected_id);
      set_two_level_selected(two_level_selected_id);
    }
  }, [menusMobile?.length, show]);
  useEffect(() => {
    setShowTip(hasBalanceOnRefAccount);
  }, [hasBalanceOnRefAccount]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTip(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, [showTip]);

  const { wallet } = getCurrentWallet();
  const [accountVisible, setAccountVisible] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    document.addEventListener('click', handleClick, false);

    return () => {
      document.removeEventListener('click', () => {}, false);
    };
  }, []);
  const setPatheState = () =>
    setPathnameState(window.location.pathname !== '/account');

  useEffect(() => {
    history.pushState = wrapHistoryMethodWithEvent('pushState');
    history.replaceState = wrapHistoryMethodWithEvent('replaceState');
    window.addEventListener('popstate', (event) => {
      setPatheState();
    });
    window.addEventListener('pushState', function () {
      setPatheState();
    });
    window.addEventListener('replaceState', function () {
      setPatheState();
    });
  }, []);

  const handleClick = (event: any) => {
    if (
      iconRef.current.contains(event.target) ||
      popupRef.current.contains(event.target)
    ) {
      return;
    }
    setShow(false);
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [show]);

  function close() {
    setShow(false);
  }
  function handleMenuClick(linkInfo: menuItemType) {
    const { children, clickEvent, url, isExternal, id } = linkInfo;
    if (clickEvent) {
      clickEvent();
      set_one_level_selected(id);
    } else if (url) {
      if (isExternal) {
        openUrl(url);
      } else {
        openUrl(url);
      }
    }
    if (clickEvent || url) {
      close();
    } else if (children) {
      if (openMenu == id) {
        setOpenMenu('');
      } else {
        setOpenMenu(id);
        setOpenChildMenu('');
      }
    }
  }
  function handleChildMenuClick(
    linkInfo_parent: menuItemType,
    linkInfo: menuItemType
  ) {
    const { children, clickEvent, url, isExternal, id } = linkInfo;
    if (clickEvent) {
      clickEvent();
      set_one_level_selected(linkInfo_parent.id);
      set_two_level_selected(id);
    } else if (url) {
      if (isExternal) {
        openUrl(url);
      } else {
        openUrl(url);
      }
    }
    if (clickEvent || url) {
      close();
    } else if (children) {
      if (openChildMenu == id) {
        setOpenChildMenu('');
      } else {
        setOpenChildMenu(id);
      }
    }
  }
  function handleGrandsonMenuClick(linkInfo: menuItemType) {
    const { clickEvent, url, isExternal } = linkInfo;
    if (clickEvent) {
      clickEvent();
    } else if (url) {
      if (isExternal) {
        openUrl(url);
      } else {
        openUrl(url);
      }
    }
    if (clickEvent || url) {
      close();
    }
  }

  function closeKeyModal() {
    setKeyModalShow(false);
  }
  return (
    <>
      <div
        className={`${
          hasBalanceOnRefAccount && pathnameState ? 'block' : 'hidden'
        } text-xs py-1.5 px-2 lg:hidden text-center`}
        style={{
          backgroundColor: 'rgb(255, 201, 64)',
          zIndex: 100,
        }}
      >
        👀 &nbsp;
        <FormattedMessage
          id="ref_account_balance_tip_mobile"
          defaultMessage="You have tokens in your ref account."
        />
        {` `}
        <span
          className={`font-bold underline cursor-pointer mx-1`}
          onClick={() => openUrl('/account?tab=ref')}
        >
          <FormattedMessage id="click" defaultMessage="Click" />
        </span>
        <FormattedMessage id="to_recover" defaultMessage="to recover." />
      </div>
      <div
        className="nav-wrap lg:hidden md:show relative xs:mb-6 md:mb-6"
        style={{
          zIndex: show ? 200 : 91,
        }}
      >
        {showTip ? <AccountTipDownByAccountID show={showTip} /> : null}
        <div
          className="flex items-center text-2xl text-white justify-between px-4"
          style={{
            height: '64px',
            background: 'rgba(8, 12, 16, 0.55)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
          }}
        >
          <AppLogo
            onClick={() => {
              window.location.href = '/';
            }}
          />
          <div className="flex items-center">
            <div
              className="flex px-1 py-1 items-center justify-center rounded-full pl-3 pr-3 text-sm"
              style={{
                border: '1px solid rgba(255, 255, 255, 0.16)',
                background: 'rgba(0, 0, 0, 0.28)',
                color: '#E7EEF2',
              }}
            >
              <span
                className="inline-block rounded-full mr-2 flex-shrink-0"
                style={{ width: 7, height: 7, background: '#3DDC97' }}
              />
              <div className="overflow-ellipsis overflow-hidden text-sm whitespace-nowrap account-name relative">
                {isSignedIn ? (
                  <div
                    className="flex items-center"
                    onClick={() => {
                      setAccountVisible(!accountVisible);
                      setShowTip(false);
                    }}
                  >
                    <span>{getAccountName(wallet.getAccountId())}</span>

                    {accountVisible ? (
                      <ArrowDownIcon className="transform rotate-180 ml-2" />
                    ) : (
                      <ArrowDownIcon className="ml-2" />
                    )}
                  </div>
                ) : (
                  <span
                    className="text-xs"
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      //modal.show();
                      handleWalletModalOpen();
                    }}
                  >
                    <FormattedMessage
                      id="connect_to_near"
                      defaultMessage="Connect to NEAR"
                    />
                  </span>
                )}
              </div>
            </div>
            {/*<div className={!isSignedIn ? 'hidden' : ' flex items-center'}>*/}
            {/*  <ConnectDot />*/}
            {/*  <ConnectDot />*/}
            {/*  <AuroraEntry*/}
            {/*    hasBalanceOnAurora={hasAuroraBalance}*/}
            {/*    extraClick={() => setAccountVisible(false)}*/}
            {/*  />*/}
            {/*</div>*/}
            <span className="ml-4" ref={iconRef} onClick={() => setShow(true)}>
              <HiMenuIcon />
            </span>
          </div>
        </div>
        <div
          className={`fixed top-0 bottom-0 left-0 z-20 w-full bg-black bg-opacity-30 backdrop-blur-lg filter-blur backdrop-filter overflow-auto ${
            show ? 'block' : 'hidden'
          }`}
          style={{
            zIndex: '300',
          }}
        >
          <div
            ref={popupRef}
            className="h-full w-4/6 float-right bg-cardBg shadow-4xl z-30 overflow-y-auto"
          >
            <div>
              <div className="flex text-white items-center justify-between p-4 border-b border-menuBorderColor">
                <div />
                <div className="flex items-center gap-2">
                  {FEATURES.buyNear ? <BuyNearButton /> : null}
                </div>
              </div>
              <div className="text-primaryText gotham_bold pb-24">
                {menusMobile?.map((linkInfo: menuItemType) => {
                  const { id, label, children } = linkInfo;
                  const isSelected = one_level_selected == id;
                  return (
                    <div key={id} className="border-b border-menuBorderColor">
                      {/* one level menu */}
                      <div
                        className={`flex px-4 py-3.5 items-center text-base justify-between ${
                          isSelected
                            ? 'bg-one_level_menu_color text-white'
                            : 'text-primaryText'
                        }`}
                        onClick={() => handleMenuClick(linkInfo)}
                      >
                        {label}
                        {children && (
                          <span className="ml-1">
                            {openMenu == id ? (
                              <ArrowDownLargeIcon className="transform rotate-180 text-white"></ArrowDownLargeIcon>
                            ) : (
                              <ArrowDownLargeIcon
                                className={`${
                                  isSelected ? 'text-white' : 'text-primaryText'
                                }`}
                              ></ArrowDownLargeIcon>
                            )}
                          </span>
                        )}
                      </div>
                      {/* two level menu */}
                      {children && (
                        <div
                          className={`${openMenu === id ? 'block' : 'hidden'}`}
                        >
                          {children?.map((link: menuItemType) => {
                            const { id, label, logo, children, renderLogo } =
                              link;
                            const isSubMenuSelected = two_level_selected == id;
                            return (
                              <div
                                className={`py-0.5 ${
                                  isSubMenuSelected
                                    ? 'bg-two_level_menu_color'
                                    : ''
                                }`}
                                key={id}
                              >
                                <div
                                  className={`flex justify-between text-left items-center pl-3 pr-4 py-3 ${
                                    isSubMenuSelected
                                      ? 'text-white'
                                      : 'text-primaryText'
                                  }`}
                                  onClick={() => {
                                    handleChildMenuClick(linkInfo, link);
                                  }}
                                >
                                  <div className="flex items-center whitespace-nowrap">
                                    {(renderLogo || logo) && (
                                      <span className="text-xl text-left w-8 flex justify-center mr-2">
                                        {renderLogo
                                          ? renderLogo({
                                              activeMenu: isSubMenuSelected,
                                            })
                                          : logo}
                                      </span>
                                    )}
                                    {label}
                                  </div>

                                  {children && (
                                    <span className="ml-1">
                                      {openChildMenu === id ? (
                                        <ArrowDownLargeIcon className="transform rotate-180 text-white"></ArrowDownLargeIcon>
                                      ) : (
                                        <ArrowDownLargeIcon className="text-primaryText"></ArrowDownLargeIcon>
                                      )}
                                    </span>
                                  )}
                                </div>
                                {/* three level menu */}
                                {children ? (
                                  <div
                                    className={`${
                                      openChildMenu == id ? 'block' : 'hidden'
                                    }`}
                                  >
                                    {children.map((grandson: menuItemType) => {
                                      const {
                                        id,
                                        label,
                                        logo,
                                        url,
                                        isExternal,
                                      } = grandson;
                                      return (
                                        <div
                                          key={id}
                                          className={`flex items-center justify-between pl-12 pr-4 py-3 my-2 w-full`}
                                          onClick={() => {
                                            handleGrandsonMenuClick(grandson);
                                          }}
                                        >
                                          <div className="flex items-center">
                                            {logo && (
                                              <span className="text-xl mr-2">
                                                {logo}
                                              </span>
                                            )}
                                            {label}
                                          </div>
                                          {url && isExternal && <OutLinkIcon />}
                                        </div>
                                      );
                                    })}
                                  </div>
                                ) : null}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {accountVisible ? (
          <AccountModel
            hasBalanceOnRefAccount={hasBalanceOnRefAccount}
            setAccountVisible={setAccountVisible}
            setKeyModalShow={setKeyModalShow}
            closeAccount={() => {
              setAccountVisible(false);
            }}
          />
        ) : null}
      </div>
      {/* {isMobile ? <Marquee></Marquee> : null} */}
      <WalletRiskCheckBoxModal
        isOpen={showWalletRisk}
        setCheckedStatus={handleAcknowledgeClick}
        onClose={() => setShowWalletRisk(false)}
      />

      {accountId && keyModalShow ? (
        <AccessKeyModal isOpen={keyModalShow} onRequestClose={closeKeyModal} />
      ) : null}
    </>
  );
}
